import axios from 'axios';

export const s3NoCacheRequestClientUtil = axios.create({
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  },
});

export const s3RequestClientUtil = axios.create();
